// SPDX-FileCopyrightText: 2022-2026 Lablup Inc. All rights reserved.
// SPDX-License-Identifier: LicenseRef-Proprietary
import React from "react";

import {
  type FeatureFlagConfig,
  useFeatureFlags,
} from "../../hooks/useFeatureFlags";

interface RequireFeatureProps {
  flag: keyof FeatureFlagConfig;
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

const RequireFeature: React.FC<RequireFeatureProps> = ({
  flag,
  fallback,
  children,
}) => {
  const { data: featureFlags } = useFeatureFlags();
  // placeholderData in useFeatureFlags ensures featureFlags is always defined,
  // so no flash-of-content guard is needed here.
  if (featureFlags?.[flag] === false) {
    return fallback ?? null;
  }
  return children;
};

export default RequireFeature;
